export default "/github.png";